import DTO from './DTO';
import {
  inn10,
  maxLength12, maxLength15, minLength10, minLength13,
  noLetters, noSpaceEnd,
  noSpaceStart, ogrn13,
  onlyDigits, onlyDigitsAndLetters,
  required,
  trimError,
  trimNoSpecStartOrEnd,
  hasValidSpacesOrQuotes, ogrnIp15,
} from '../utils/validation';
import { FEDERAL_LAW_NUMBERS, USER_TYPE } from '../configs';

class JuridicalDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'legal_entity_form',
        type: String,
        validators: [params?.federal_law_number === FEDERAL_LAW_NUMBERS.FEDERAL_LAW_69 ? () => {} : required],
        labelKey: 'legal_entity_form',
      },
      {
        name: 'full_name',
        type: String,
        validators: [params?.optional ? () => {} : required, hasValidSpacesOrQuotes],
        labelKey: 'full_name_legal',
      },
      {
        name: 'identity_change_document',
        type: String,
        validators: [],
        labelKey: 'media.identity_change_document',
      },
      {
        name: 'address_change_document',
        type: String,
        validators: [],
        labelKey: 'media.address_change_document',
      },
      {
        name: 'office_address',
        type: String,
        validators: [],
        labelKey: 'new.address',
      },
      {
        name: 'ogrn_change_document',
        type: String,
        validators: [],
        labelKey: 'media.ogrn_change_document',
      },
      {
        name: 'ogrip_change_document',
        type: String,
        validators: [],
        labelKey: 'media.ogrip_change_document',
      },
      {
        name: 'short_name',
        type: String,
        validators: [params?.optional ? () => {} : required, hasValidSpacesOrQuotes],
        labelKey: 'short_name_legal',
      },
      {
        name: 'inn',
        type: String,
        validators: [required, onlyDigits, noLetters, trimError, trimNoSpecStartOrEnd, noSpaceStart, noSpaceEnd, inn10],
        labelKey: 'inn',
      },
      {
        name: 'ogrn',
        type: String,
        validators: [params?.optional ? () => {} : required, onlyDigitsAndLetters, trimError, trimNoSpecStartOrEnd, noSpaceStart, noSpaceEnd, params?.legal_entity_type === USER_TYPE.LEGAL ? ogrn13 : ogrnIp15],
        labelKey: 'ogrn',
      },
      {
        name: 'address',
        type: String,
        validators: [params?.optional || params?.federal_law_number === FEDERAL_LAW_NUMBERS.FEDERAL_LAW_69 ? () => {} : required],
        labelKey: 'address',
      },
      {
        name: 'legal_address',
        type: String,
        validators: [params?.optional || params?.federal_law_number === FEDERAL_LAW_NUMBERS.FEDERAL_LAW_69 ? () => {} : required],
        labelKey: 'legal_address',
      },
      {
        name: 'phone',
        type: String,
        validators: [required],
        labelKey: 'phone',
      },
      {
        name: 'email',
        type: String,
        validators: {},
        labelKey: 'pd.email',
      },
      {
        name: 'applicant_identity_files',
        type: String,
        validators: [],
        labelKey: 'identity_files',
        couldBeNull: true,
      },
      {
        name: 'isMatch',
        type: Boolean,
        validators: [],
        labelKey: 'isMatch',
        couldBeNull: true,
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      legal_entity_form: this.legal_entity_form,
      full_name: this.full_name,
      short_name: this.short_name,
      inn: this.inn,
      ogrn: this.ogrn,
      address: this.address,
      legal_address: this.legal_address,
      phone: this.phone,
      email: this.email,
    };
  }
}

export default JuridicalDTO;
